module.exports = __webpack_public_path__ + "static/media/IMG_1641.32df544a.JPG";